import { useTranslation } from 'react-i18next'

import { useGetQuoteJobPrice, useGetQuotePrice, type Quote } from '../../../modules/quotes'
import { mergeClassName } from '../../../utils/mergeClassName'
import Price from '../../Price'
import { useQuoteContext } from '../QuoteComponent.context'

type QuotePriceProps = {
  quote: Quote
}

const QuotePrice: React.FC<QuotePriceProps> = ({ quote }) => {
  const { t } = useTranslation()
  const { promoCode, jobId } = useQuoteContext()
  const getQuotePrice = useGetQuotePrice()
  const getQuoteJobPrice = useGetQuoteJobPrice()

  const jobIndex = jobId ? quote.jobs.findIndex(job => job.jobId === jobId) : undefined

  if (jobIndex === -1) {
    return null
  }

  const {
    price,
    originalPrice,
    discount,
  } = typeof jobIndex === 'number'
    ? getQuoteJobPrice(quote, jobIndex, { promoCode })
    : getQuotePrice(quote, { promoCode })

  return (
    <div>
      <div className="flex items-center">
        <div className={mergeClassName(
          'flex flex-col font-body2 text-2xl sm:text-3xl md:text-4xl text-neutral-700 w-full whitespace-nowrap items-center md:items-end',
        )}
        >
          { discount && (
            <div className="-mb-1 -mt-2 text-neutral-400 child:line-through">
              <Price amount={originalPrice} className="text-lg child:text-lg" />
            </div>
          ) }

          <Price amount={price} className="text-3xl md:text-4xl" />
        </div>
      </div>

      <div className="items-end justify-end gap-1 text-center text-sm md:flex">
        <div className="md:flex:block inline text-xs font-bold uppercase text-slate-400">
          { t('quotes.quote.estimate') }
        </div>
        <div className="md:flex:block inline whitespace-nowrap text-slate-400">
          ({ t('quotes.quote.plusTaxes') })
        </div>
      </div>
    </div>
  )
}

export default QuotePrice
